import { useEffect, useRef } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function getSessionId() {
  let sid = localStorage.getItem('magic_session_id');
  if (!sid) {
    sid = 'sess_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem('magic_session_id', sid);
  }
  return sid;
}

async function postJson(path, body) {
  try {
    await fetch(`${BACKEND_URL}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    });
  } catch (e) {
    /* swallow */
  }
}

export function useAnalytics() {
  const startedAt = useRef(Date.now());
  const flushedAt = useRef(Date.now());
  const tickRef = useRef(null);

  useEffect(() => {
    const sid = getSessionId();
    // Track initial visit
    postJson('/api/track/visit', {
      session_id: sid,
      path: window.location.pathname,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
    });

    // Setup global trackAction helper
    window.trackAction = (action, label) => {
      postJson('/api/track/action', {
        session_id: sid,
        action,
        label: label || null,
        path: window.location.pathname,
      });
    };

    // Track clicks on key elements
    const onClick = (e) => {
      const t = e.target.closest('a, button');
      if (!t) return;
      const href = t.getAttribute('href') || '';
      if (href.startsWith('tel:')) window.trackAction('click_phone', href.replace('tel:', ''));
      else if (href.startsWith('mailto:')) window.trackAction('click_email');
      else if (href.includes('wa.me')) window.trackAction('click_whatsapp');
      else if (href.includes('facebook')) window.trackAction('click_facebook');
      else if (href.includes('instagram')) window.trackAction('click_instagram');
      else if (t.textContent && t.textContent.trim().toLowerCase().includes('emergenza')) window.trackAction('click_emergency');
      else if (t.textContent && t.textContent.trim().toLowerCase().includes('scopri di pi')) window.trackAction('click_service_detail');
    };
    document.addEventListener('click', onClick, true);

    // Flush session duration every 15s
    const flush = (extra = 0) => {
      const now = Date.now();
      const secs = Math.floor((now - flushedAt.current) / 1000) + extra;
      flushedAt.current = now;
      if (secs > 0 && secs < 1800) {
        postJson('/api/track/session', {
          session_id: sid,
          duration_seconds: secs,
          path: window.location.pathname,
        });
      }
    };
    tickRef.current = setInterval(flush, 15000);

    const onHide = () => flush();
    document.addEventListener('visibilitychange', onHide);
    window.addEventListener('beforeunload', onHide);

    return () => {
      clearInterval(tickRef.current);
      document.removeEventListener('click', onClick, true);
      document.removeEventListener('visibilitychange', onHide);
      window.removeEventListener('beforeunload', onHide);
      flush();
    };
  }, []);
}
